import { Injectable } from '@angular/core';

import { MatSnackBar } from '@angular/material';

@Injectable()
export class ApplicationNotificationService {

  constructor(public snackBar: MatSnackBar) {}

  public addGrowl(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 10000
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/application-notification.service.ts